import React, { useState } from "react";

const COUNTRY_CODES = [
  { code: "+1", country: "US" },
];

interface NumberInputProps {
  label: string;
  name: string;
  value: string;
  countryCode?: string ;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  minLength?: number;
  className?: string;
}

const NumberInput: React.FC<NumberInputProps> = ({
  label,
  name,
  value,
  onChange,
  countryCode = "+1",
  placeholder = "",
  required = false,
  disabled = false,
  error,
  minLength,
  className = "",
}) => {


  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (minLength && e.target.value.length < minLength) {
      e.target.setCustomValidity(`Minimum ${minLength} digits required`);
    } else {
      e.target.setCustomValidity("");
    }
    onChange(e);
  };

  return (
    <div className="w-full flex flex-col gap-1">
  <div className="flex">
    {/* Country Code Select */}
    <select
      value={countryCode}
      onChange={onChange}
      className="w-20 px-1 py-2 text-sm border border-gray-300 bg-white text-gray-900 rounded-l-md focus:outline-none focus:border-transparent"
    >
      {COUNTRY_CODES.map((c) => (
        <option key={c.code} value={c.code} className="text-sm">
          {c.code}{"("+c.country+")"}
        </option>
      ))}
    </select>

    {/* Number Input */}
    <input
      id={name}
      name={name}
      type="number"
      value={value}
      placeholder={placeholder}
      onChange={handleInput}
      required={required}
      disabled={disabled}
      className={`${className} w-full min-[200px]: text-black/90 no-spinner flex-1 border border-gray-300 border-l-0 rounded-r-md px-3 py-2 text-sm focus:outline-none focus:border-transparent`}
      inputMode="numeric"
      minLength={minLength}
    />
  </div>

  {error && <p className="text-sm text-red-500">{error}</p>}
</div>

  );
};

export default NumberInput;
